// AI-CONTEXT: See docs/features/update-aanvragen.md

/**
 * Updateverzoeken, nieuwste bovenaan.
 *
 * Bewust client-side en niet met een Firestore-orderBy: een document zonder
 * `Timestamp` valt dan stil uit de query, en dat is precies het document waar
 * iemand naar op zoek is (een backfill of een half geschreven verzoek). Hier
 * zakt het naar onderen in plaats van te verdwijnen.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-orderby-excludes-missing-field
 *
 * Bij een gelijke datum beslist het ID. Zonder die vaste tiebreak verspringt de
 * lijst bij elke nieuwe snapshot, en na een backfill dragen meerdere verzoeken
 * hetzelfde moment.
 *
 * @template {{ID?: string, Timestamp?: {toDate?: () => Date}|null}} T
 * @param {Array<T>|null|undefined} requests - Documenten uit UpdateRequests
 * @returns {Array<T>} Nieuwe, gesorteerde lijst; de invoer blijft ongemoeid
 */
const sortUpdateRequests = (requests) => {
    if (!Array.isArray(requests)) return []

    const momentOf = (request) => {
        if (typeof request?.Timestamp?.toDate !== 'function') return null
        const time = request.Timestamp.toDate().getTime()
        return Number.isNaN(time) ? null : time
    }

    const byId = (a, b) => String(a?.ID || '').localeCompare(String(b?.ID || ''))

    return [...requests].sort((a, b) => {
        const left = momentOf(a)
        const right = momentOf(b)

        if (left === null && right === null) return byId(a, b)
        if (left === null) return 1
        if (right === null) return -1

        return left === right ? byId(a, b) : right - left
    })
}

export default sortUpdateRequests
